var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Mastercard-logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.358,
    height: 20.014,
    viewBox: "0 0 32.358 20.014",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2569",
    "data-name": "Group 2569"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect19",
    width: 8.757,
    height: 15.732,
    transform: "translate(11.788 2.141)",
    fill: "#ff5a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_330_",
    d: "M12.371,10.007a10.035,10.035,0,0,1,3.808-7.866,10,10,0,1,0-6.172,17.873,9.953,9.953,0,0,0,6.172-2.141A9.987,9.987,0,0,1,12.371,10.007Z",
    fill: "#eb001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M515.779,10.007A10,10,0,0,1,499.6,17.873a10.028,10.028,0,0,0,0-15.732,10,10,0,0,1,16.179,7.866Z",
    transform: "translate(-483.421)",
    fill: "#f79e1b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.902001354a709333a56f996029e768df.svg";
export { ForwardRef as ReactComponent };